<template>
  <div class="row p-2">
    <div class="col">
      <div class="pull-left">
        <a
          class="btn btn-success"
          v-show="editmode != true"
          href="#"
          @click="saveField"
          >Save</a
        >
        <a
          href="#"
          v-show="editmode"
          @click="updateRelationship"
          class="btn btn-success"
          >Update</a
        >
        <a class="btn" href="#" @click="cancel">Cancel</a>
      </div>
      <br />
      <br /><br />
      <form>
        <div class="row">
          <div class="form-group col-4">
            <label class="control-label">Name</label>
            <input
              type="text"
              readonly
              v-model="formdata.name"
              class="form-control"
            />
          </div>
          <div class="form-group col-4">
            <label class="control-label">Show Detail Panel</label>
            <select class="form-control" v-model="formdata.isPanelVisible">
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="form-group col-4">
            <label class="control-label">Primary Module</label>
            <select class="form-control" v-model="formdata.pmodule" disabled>
              <option
                v-for="(element, key) in modulelist"
                :key="key"
                :value="element.name"
              >
                <!-- {{ element.label }} -->
                {{ element.name }}
              </option>
            </select>
          </div>
          <div class="form-group col-4">
            <label class="control-label">Relationship</label>
            <select
              @change="onChange($event)"
              class="form-control"
              :disabled="editmode"
              v-model="formdata.relation"
            >
              <option>OneToOne</option>
              <option>OneToMany</option>
              <option>ManyToOne</option>
              <option>ManyToMany</option>
              <option>MorphOneToOne</option>
              <option>MorphOneToMany</option>
              <option>MorphManyToMany</option>
            </select>
          </div>

          <div v-show="isNormVisible" class="form-group col-4">
            <label class="control-label">Related Module</label>
            <select
              class="form-control"
              :disabled="editmode"
              v-model="formdata.rmodule"
            >
              <option
                v-for="(element, key) in modulelist"
                :key="key"
                :value="element.name"
              >
                <!-- {{ element.label }} -->
                {{ element.name }}
              </option>
            </select>
          </div>
        </div>

        <!-- multi select dropdown with all moduleList -->

        <div v-show="isMorphVisible" class="grid grid-cols-3 gap-4">
          <div class="dx-fieldset col-span-2">
            <div class="dx-field">
              <div class="dx-field-label">Related Modules</div>

              <div class="dx-field-value">
                <DxDropDownBox
                  v-model:value="gridBoxValue"
                  :defer-rendering="false"
                  :show-clear-button="true"
                  :data-source="modulelist"
                  display-Expr="name"
                  value-Expr="name"
                  placeholder="Select modules..."
                >
                  <template #content="{ data }">
                    <DxDataGrid
                      :data-source="modulelist"
                      :columns="gridColumns"
                      :allow-column-reordering="true"
                      :allow-column-resizing="true"
                      :column-auto-width="true"
                      :column-height="100"
                      :column-min-width="200"
                      :show-column-chooser="true"
                      key-expr="name"
                      :hover-state-enabled="true"
                      v-model:selected-row-keys="gridBoxValue"
                      :on-selection-changed="onSelectionChanged"
                      @selectionchanged="onSelectionChanged"
                    >
                      <DxSelection mode="multiple" />
                      <DxFilterRow :visible="true" />
                    </DxDataGrid>
                  </template>
                </DxDropDownBox>
              </div>
            </div>
          </div>

          <div>
            <strong class="mb-2">Selected Modules</strong>
            <div v-for="value in selectedModuleList">
              {{ value }}
            </div>
          </div>
        </div>
        <!-- End-->
      </form>
    </div>
  </div>
</template>
<script>
var formdata = {};
import DxDropDownBox from "devextreme-vue/drop-down-box";
const dataGridRef = "dataGrid";
import {
  DxDataGrid,
  DxSelection,
  DxPaging,
  DxFilterRow,
  DxScrolling,
} from "devextreme-vue/data-grid";
export default {
  props: {
    modulekey: String,
    slug: String,
    studio: Boolean,
    tabData: {
      type: Object,
      default: () => ({}),
    },
    edit: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    DxDropDownBox,
    DxDataGrid,
    DxSelection,
    DxPaging,
    DxFilterRow,
    DxScrolling,
  },
  data() {
    return {
      modulenm: this.modulekey,
      modulelist: [],
      formdata,
      gridBoxValue: ["TenantList"],
      isMorphVisible: false,
      isNormVisible: true,
      gridColumns: ["name", "label", "module_type"],
      dataGridRef,
      selectedModuleList: [],
      editmode: this.edit,
    };
  },
  computed: {
    dataGrid: function () {
      return this.$refs[dataGridRef].instance;
    },
  },
  methods: {
    getFields() {
      this.errors = {};
      axios
        .get("/" + this.slug + "/module/unfilterlist")
        .then((response) => {
          console.log("UNFILTER", response.data.results);
          this.modulelist = response.data.results;
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors || {};
          }
        });
    },
    onChange(event) {
      if (event.target.value.includes("Morph")) {
        this.isMorphVisible = true;
        this.isNormVisible = false;
        // alert(event.target.value);
      } else {
        this.isNormVisible = true;
        this.isMorphVisible = false;
      }
    },
    onSelectionChanged(e) {
      console.log("SLECTED_ROW_KEY", e.component.option("selectedRowKeys"));
      this.selectedModuleList = e.component.option("selectedRowKeys");
      //  this.gridBoxValue = e.component.option("selectedRowKeys");
    },
    saveField() {
      this.errors = {};

      if (this.formdata.relation != "ManyToMany") {
        this.formdata.template = "form-rlt";
      }
      if (this.formdata.relation.includes("Morph")) {
        this.formdata.morphModules = this.selectedModuleList;
        this.formdata.rmodule = this.modulekey;
      }
      let parameters = {
        module: this.modulekey,
        studio: this.studio,
        data: this.formdata,
      };

      axios
        .post("/" + this.slug + "/relationship", parameters)
        .then((response) => {
          //this.DD_List = response.data;
          window.location.reload();

          // this.cancel();
          // console.log(response.data);
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.errors = error.response.data.errors || {};
          }
        });
    },
    cancel() {},

    updateRelationship() {
      // console.log("FORM  RLT DATA TEST",this.formdata);
      this.$inertia.put(route("relationship.update", [this.slug, "sds"]), {
        _method: "put",
        data: "ss",
        module: this.modulekey,
        studio: this.studio,
        data: this.formdata,
      });
    },
  },
  mounted() {
    console.log("FORM_DATA", this.formdata);
    formdata.isPanelVisible = "Yes";
  },
  created: function () {
    this.formdata.pmodule = this.modulekey;
    this.getFields();
    if (this.edit == true) {
      this.formdata = this.tabData;
    }
  },
};
</script>
<style scoped>
.dx-fieldset {
  height: 50px;
}
</style>
